import { IS_INLINE_EDIT } from "./constants";

export const setIsInlineUpdate = (id) => ({
    type: IS_INLINE_EDIT,
    payload: { id }
})